export const ListOfImages = 'ListOfImages';
export const SliderFragranceTestimonyCards = 'SliderFragranceTestimonyCards';
export const SliderImageAndContent = 'SliderImageAndContent';
export const SliderOfSlider = 'SliderOfSlider';
